import { ENV } from '$env';
import { ServerProvider } from '$providers/server';
import { ViewProvider } from '$providers/view';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Events, NavController, NavParams } from 'ionic-angular';
import { normalizar, validarCpf } from '$util/cpfutil';
import { SenhaValidator } from '$util/senhavalidator';
import { getDddTelefone, validarTelefone } from '$util/telefoneutil';

const EMAIL_PATTERN: string = '[a-zA-Z][\\w\\._-]+@' + '\\w[\\w_-]*(\\.[\\w_-]+)+'
const NOME_INVALIDO_PATTERN: string = '.*[^A-Za-záÁéÉíÍóÓúÚâÂêÊôÔãÃõÕçÇüÜàÀ \'\\-\\.ªº°].*';

@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage implements OnInit {

  web = false;

  cidadaoForm: FormGroup;
  validateMsg: string = '';

  constructor(private navCtrl: NavController, private navParams: NavParams, private formBuilder: FormBuilder,
    private events: Events, private viewProvider: ViewProvider, private serverProvider: ServerProvider) {

    this.web = ENV.web;
  }

  ngOnInit(): void {
    let temp: string = this.navParams.get('cpf');

    this.cidadaoForm = this.formBuilder.group({
      cpf: [validarCpf(temp) ? temp : ''],
      nome: [''],
      email: [''],
      celular: [''],
      telefone: [''],
      senha: [''],
      confirmacaoSenha: [''],
      captcha: [''],
    });
  }

  validar(cidadao: any) {
    this.validateMsg = '';

    validarCpf(cidadao.cpf, (msg) => this.addValidateMsg(msg))

    if (cidadao.nome == null || cidadao.nome.trim() == '')
      this.addValidateMsg('- <b>Nome</b> é obrigatório.');
    else {
      if (cidadao.nome.match(NOME_INVALIDO_PATTERN))
        this.addValidateMsg('- <b>Nome</b> contém caracteres inválidos.');

      var nomes: string[] = cidadao.nome.split(' ');
      if (nomes.length < 2)
        this.addValidateMsg('- Informe <b>Nome</b> e <b>Sobrenome</b>.');
    }

    let celularInformado = true;
    if (cidadao.celular == null || cidadao.celular.trim() == '')
      celularInformado = false;
    else {
      var dddCelular = getDddTelefone(cidadao.celular);
      validarTelefone(dddCelular['ddd'], dddCelular['numero'], 'celular', (msg) => this.addValidateMsg(msg));
    }

    var dddFixo = getDddTelefone(cidadao.telefone);
    if (dddFixo['ddd'] != null && dddFixo['ddd'] != '')
      validarTelefone(dddFixo['ddd'], dddFixo['numero'], 'residencial', (msg) => this.addValidateMsg(msg));

    if (!celularInformado && (!cidadao.email || !cidadao.email.length)) {
      this.addValidateMsg('- É necessário informar o <b>E-mail</b> ou <b>Celular</b> para ativação do seu cadastro e lhe manter informado sobre suas solicitações.');
    } else {
      if (cidadao.email != null && cidadao.email.length && !cidadao.email.match(EMAIL_PATTERN))
        this.addValidateMsg('- <b>E-mail</b> inválido.');
    }

    new SenhaValidator(cidadao.senha, cidadao.confirmacaoSenha).validate((msg) => this.addValidateMsg(msg));
  }

  addValidateMsg(msg: string) {
    this.validateMsg += (this.validateMsg.length > 0 ? '<br>' : '') + msg;
  }

  onSubmit(cidadao: any) {
    this.validar(cidadao);
    if (this.validateMsg.trim() != '') {
      this.viewProvider.showWarning(this.validateMsg)
      this.validateMsg = '';
      return;
    }

    this.okAfterAgreeTerms(cidadao);

    /*this.viewProvider.showModalPage(TermoAceiteViewPage, {}, (data) => {
      if (data && data.concordo) {
        this.okAfterAgreeTerms(cidadao);
      } else {
        this.viewProvider.showMessage("Os termos de uso não foram aceitos.");
      }
    });*/
  }

  okAfterAgreeTerms(cidadao: any) {
    var celularDdd = getDddTelefone(cidadao.celular);
    var residencialDdd = getDddTelefone(cidadao.residencial);

    const operacao = (ENV.web)
      ? 'REGISTRAR_WEB'
      : 'REGISTRAR_MOBILE';

    let data: any = {
      operacao: operacao,
      cpf: normalizar(cidadao.cpf),
      nome: cidadao.nome,
      telefone: (residencialDdd['ddd'] != null ? residencialDdd['ddd'] + '-' + residencialDdd['numero'] : null),
      email: cidadao.email,
      senha: cidadao.senha,
      captcha: cidadao.captcha
    };


    if (cidadao.celular && cidadao.celular.length > 0) {
      data.celular = celularDdd['ddd'] + '-' + celularDdd['numero'];
    }

    this.serverProvider.postData(data).subscribe(
      success => {
        this.viewProvider.showMessage(success['mensagem'], () => {
          let user = { cpf: data.cpf, password: data.senha };
          this.navCtrl.getPrevious().getNavParams().data['cpf'] = cidadao.cpf;
          this.navCtrl.pop();
          this.events.publish('login:submit', user, true);
        });
      }, error => {

      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/register/register.ts